<template>
  <div v-if="showModuloForm === false">
    <MarketingModules></MarketingModules>
  </div>
  <div class="page tipos-venda-page" v-else-if="showModuloForm === true">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton
            text="Novo tipo de venda"
            type="primario"
            beforeIcon="fas fa-plus"
            @click="onNew"
          />
        </FormButtonGroup>
      </template>

      <v-alert
        color="primario"
        outlined
        dense
        class="tipos-venda-info-alert mb-4"
        icon="fas fa-info-circle"
      >
        Tipos de venda sem formas de pagamento vinculadas liberam
        <strong>todas as formas da loja</strong> no LifeGrowth. O
        <strong>código</strong> é enviado ao ERP como condição de venda.
      </v-alert>

      <v-row dense align="center" class="mb-2">
        <v-col cols="12" sm="6" md="4">
          <FormField
            label="Buscar nome ou código"
            v-model="busca"
            clearable
            dense
          />
        </v-col>
        <v-col cols="12" sm="4" md="3">
          <FormSelect
            label="Status"
            v-model="filtroStatus"
            :options="statusOptions"
            dense
          />
        </v-col>
      </v-row>

      <DataTable
        :headers="headers"
        :data="linhasFiltradas"
        hideFooter
        classe="elevation-0"
        @click="onRowClick"
      >
        <template v-slot:nome="{ row }">
          <span class="tipos-venda-col-with-icon">
            <v-icon
              v-if="row.registro_sistema"
              color="grey"
              class="mr-1"
              size="13"
              title="Registro do sistema: nome e código não podem ser alterados"
            >
              fas fa-lock
            </v-icon>
            <span>{{ row.nome }}</span>
          </span>
        </template>
        <template v-slot:padrao="{ col }">
          <Chip
            v-if="col"
            color="primario"
            :small="true"
            dense
            rounded
            text="PADRÃO"
            icon="fas fa-star"
            :icon-size="12"
          />
          <span v-else class="grey--text">—</span>
        </template>
        <template v-slot:ativo="{ col }">
          <Chip
            v-if="col"
            color="green"
            :small="true"
            dense
            rounded
            text="ATIVO"
            icon="fas fa-check-circle"
            :icon-size="14"
          />
          <Chip
            v-else
            color="grey"
            :small="true"
            dense
            rounded
            text="INATIVO"
            icon="fas fa-minus-circle"
            :icon-size="14"
          />
        </template>
        <template v-slot:idformapagtos="{ col }">
          <Chip
            v-if="col && col.length"
            color="primario"
            :small="true"
            dense
            outlined
            rounded
            :text="`${col.length} ${col.length === 1 ? 'forma' : 'formas'}`"
            icon="fas fa-credit-card"
            :icon-size="12"
          />
          <span v-else class="grey--text">Todas</span>
        </template>
        <template v-slot:acoes="{ row }">
          <FormButtonMenu
            icon
            :options="opcoesLinha(row)"
            :loading="!!loadingRow[row.idtipovenda]"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import Panel from "@/components/Panel";
import Chip from "@/components/Chip";
import DataTable from "@/components/DataTable";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import FormField from "@/components/form/FormField";
import FormSelect from "@/components/form/FormSelect";
import MarketingModules from "@/components/MarketingModules";
import confirmAlert from "@/mixins/confirmAlert";
import { mapGetters } from "vuex";
import { ModulesEnum } from "@/store/actions/modulesEnum";
import { TIPO_VENDA_LIST, TIPO_VENDA_REMOVE } from "@/store/actions/tipoVenda";

const BASE_ROUTE = "/fornecedor/cadastro/tipos-venda";

export default {
  name: "TiposVenda",
  components: {
    Panel,
    Chip,
    DataTable,
    FormButton,
    FormButtonGroup,
    FormButtonMenu,
    FormField,
    FormSelect,
    MarketingModules
  },
  mixins: [confirmAlert],
  data: () => ({
    modulosForm: [ModulesEnum.LIFEGROWTH],
    tiposVenda: [],
    loadingRow: {},
    busca: "",
    filtroStatus: "todos",
    statusOptions: [
      { text: "Todos", value: "todos" },
      { text: "Ativos", value: "ativos" },
      { text: "Inativos", value: "inativos" }
    ],
    headers: [
      { text: "Nome", value: "nome", sortable: false },
      { text: "Código", value: "codigo", sortable: false },
      { text: "Padrão", value: "padrao", align: "center", sortable: false },
      { text: "Status", value: "ativo", align: "center", sortable: false },
      {
        text: "Formas de pagamento",
        value: "idformapagtos",
        align: "center",
        sortable: false
      },
      {
        text: "Opções",
        value: "acoes",
        clickable: false,
        align: "center",
        sortable: false
      }
    ]
  }),
  computed: {
    ...mapGetters(["getFornecedorId", "moduloFornecedorAtivo"]),
    showModuloForm() {
      return this.moduloFornecedorAtivo(this.modulosForm);
    },
    /** A API já ordena: padrão primeiro, depois por nome. */
    linhasFiltradas() {
      const termo = (this.busca || "").trim().toLowerCase();
      return this.tiposVenda.filter(tipo => {
        if (this.filtroStatus === "ativos" && !tipo.ativo) return false;
        if (this.filtroStatus === "inativos" && tipo.ativo) return false;
        if (!termo) return true;
        return (
          (tipo.nome || "").toLowerCase().includes(termo) ||
          (tipo.codigo || "").toLowerCase().includes(termo)
        );
      });
    }
  },
  watch: {
    getFornecedorId() {
      this.carregar();
    }
  },
  created() {
    this.carregar();
  },
  methods: {
    carregar() {
      if (!this.getFornecedorId) return;
      this.$store
        .dispatch(TIPO_VENDA_LIST)
        .then(resp => {
          this.tiposVenda = (resp && resp.data) || [];
        })
        .catch(() => {});
    },
    onClose() {
      this.carregar();
    },
    onNew() {
      this.$router.push(`${BASE_ROUTE}/novo`);
    },
    onRowClick(item) {
      if (!item || !item.idtipovenda) return;
      this.$router.push(`${BASE_ROUTE}/${item.idtipovenda}`);
    },
    opcoesLinha(row) {
      const opcoes = [{ text: "Editar", value: "edit" }];
      if (!row.registro_sistema) {
        opcoes.push({ text: "Excluir", value: "delete" });
      }
      return opcoes;
    },
    selectOption(item, option) {
      if (option.value === "edit") {
        return this.onRowClick(item);
      }
      if (option.value === "delete") {
        return this.onDelete(item);
      }
    },
    onDelete(item) {
      const options = {
        title: `Excluir tipo de venda "${item.nome}"?`,
        text:
          "O tipo deixará de aparecer no backoffice e no LifeGrowth. O código ficará livre para um novo cadastro."
      };
      this.confirmSwal(options, async () => {
        this.$set(this.loadingRow, item.idtipovenda, true);
        try {
          await this.$store.dispatch(TIPO_VENDA_REMOVE, item.idtipovenda);
          this.$vueOnToast.pop("success", "Tipo de venda excluído com sucesso");
          this.carregar();
        } catch (err) {
          /* ERRORS_SHOW na action */
        } finally {
          this.$set(this.loadingRow, item.idtipovenda, false);
        }
      });
    }
  }
};
</script>

<style scoped>
.tipos-venda-col-with-icon {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
.tipos-venda-info-alert {
  font-size: 13px;
  line-height: 1.5;
  border-radius: 14px !important;
  border-left-width: 5px !important;
  border-left-style: solid !important;
  border-left-color: var(--primary-color, #1976d2) !important;
}
</style>
